const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

    (binding.modules['mfrm-utag-data'] = {
        c: () => require('partner/modules/mfrm-utag-data/mfrm-utag-data.tsx'),
        $type: 'scriptModule',
        da: [{name:'categoryPageSummary',  path:'modules/mfrm-category-page-summary/mfrm-category-page-summary.action', runOn: 0},{name:'listPageStateBuyBox',  path:'modules/mfrm-buybox/list-page-state-buybox', runOn: 0},{name:'productPageSummary',  path:'modules/mfrm-product-page-summary/mfrm-product-page-summary.action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'mfrm-utag-data',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mfrm-utag-data'
    });
        

        {
            const sanitizedActionPath = 'modules/mfrm-buybox/list-page-state-buybox';
            let dataAction = require('partner/modules/mfrm-buybox/list-page-state-buybox');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'modules/mfrm-category-page-summary/mfrm-category-page-summary.action';
            let dataAction = require('partner/modules/mfrm-category-page-summary/mfrm-category-page-summary.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        {
            const sanitizedActionPath = 'modules/mfrm-product-page-summary/mfrm-product-page-summary.action';
            let dataAction = require('partner/modules/mfrm-product-page-summary/mfrm-product-page-summary.action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|mfrm-utag-data|mfrm-utag-data'] = {
                c: () => require('partner/modules/mfrm-utag-data/mfrm-utag-data.view.tsx'),
                cn: '__local__-__local__-mfrm-utag-data'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };